import { render } from "./Register.vue?vue&type=template&id=6d874554&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=6d874554&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\City Hoardings\\City_Hoardings_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d874554"]])

export default __exports__